// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"60d95013","131":"4d7b216a","228":"9870e30b","335":"bb5890f0","570":"99c0bb8d","709":"3e406882"}[chunkId] + ".js";
};